// Chrome caps cookie lifetime at 400 days - the closest thing to "forever" a cookie can express.
const maxAgeSeconds = 60 * 60 * 24 * 400;

export async function setCookie(name: string, value: string | null): Promise<void> {
	if (typeof cookieStore === "undefined") {
		// Fallback for browsers that don't support the cookie store API
		if (value === null) {
			document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Strict; Secure`;
			return;
		}
		document.cookie = `${name}=${value}; Max-Age=${maxAgeSeconds}; path=/; SameSite=Strict; Secure`;
		return;
	}

	if (value === null) {
		await cookieStore.delete({
			name,
			path: "/",
		});
		return;
	}
	await cookieStore.set({
		name,
		value,
		sameSite: "strict",
		path: "/",
		expires: Date.now() + maxAgeSeconds * 1000,
	});
}
